"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgPhoneOpen(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 15
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 3H.5M6 0l2 3-2 3M18.23.838c.497.443.809.722.936.837.707.629.82 1.519.342 2.67-.718 1.726-3.41 5.889-9.272 9.407-1.294.91-2.456.705-2.99 0a72.88 72.88 0 00-1.046-1.35c-.38-.586-.22-1.13.48-1.632 1.048-.753.713-.487 1.57-1.075.857-.587.85-.456 1.986 0 1.136.456 1.147.854 2.273-.22a83.9 83.9 0 002.885-2.938c.44-.413.44-.929 0-1.547-.66-.927-.66-1.283 0-2.3A19.55 19.55 0 0116.752.838c.49-.443.982-.443 1.478 0z",
    fill: "none",
    stroke: "#007AFF"
  }));
}

var MemoSvgPhoneOpen = /*#__PURE__*/React.memo(SvgPhoneOpen);
var _default = MemoSvgPhoneOpen;
exports["default"] = _default;